// extracted by mini-css-extract-plugin
export var cardIcon = "_6f-4";
export var checkboxCard = "_6f-0";
export var checkboxCardSelected = "_6f-3";
export var disabled = "_6f-1";
export var outerBorder = "_6f-2";
export var spacerMedium = "_6f-7";
export var spacerSmall = "_6f-6";
export var spacerXsmall = "_6f-5";